import React, { useEffect, useState } from 'react';

import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

/*
Confirmation popup
 */
const Confirmation = ({
	title,
	actionLabel,
	onAction,
	cancelLabel,
	onCancel,
}) => {
	return (
		<Modal
			show = {true}
			onHide = {onCancel}>
			<Modal.Header>
				<Modal.Title>
					{title}
				</Modal.Title>
			</Modal.Header>
			<Modal.Footer>
				<Button
					onClick = {onAction}>
					{actionLabel}
				</Button>
				<Button
					onClick = {onCancel}>
					{cancelLabel}
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default Confirmation;
